
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.18 3.406L3.28 2.242c-.5-.307-1.143-.57-1.93-.789L1.524.79c1 .23 1.873.547 2.618.953L5.71.86l.344.602-1.266.68c.77.562 1.354 1.31 1.75 2.242.401.932.602 2.028.602 3.289 0 .927-.123 1.721-.368 2.383-.24.661-.622 1.172-1.148 1.53-.52.36-1.185.54-1.992.54-1.068 0-1.888-.31-2.461-.93C.604 10.575.32 9.69.32 8.54c0-.797.136-1.482.407-2.055.276-.573.669-1.01 1.18-1.312.51-.302 1.109-.453 1.796-.453.365 0 .693.052.985.156.296.099.578.258.843.477l.094-.055c-.323-1.1-.89-1.98-1.703-2.64l-2.399 1.35-.343-.6zm.61 4.961c0 1.021.17 1.8.515 2.336.349.537.843.805 1.484.805.417 0 .766-.117 1.047-.352.286-.234.503-.586.648-1.054.146-.47.22-1.053.22-1.75 0-.636-.076-1.18-.227-1.633-.151-.459-.37-.802-.657-1.032-.286-.234-.635-.351-1.047-.351-.364 0-.674.075-.93.226-.25.152-.455.362-.616.633a2.99 2.99 0 00-.336.97c-.068.369-.102.77-.102 1.202z","fill":"currentColor"}})])
          )
        }
      }
    